<template>
  <div class="fa" style="padding: 0 10px;">
    <div class="right">
      <div class="title" style="">
        威富通商户入驻
      </div>
      <el-scrollbar wrapStyle="height: 500px;overflow-x:hidden;" style="">
        <swift ref="swiftRef" :who="'service'"></swift>
      </el-scrollbar>
      <div style="text-align:right">
        <el-button type="success" @click="createNewSwift">新建</el-button>
        <el-button type="primary" @click="saveType">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
/* esline-disable */
import swift from "../../components/swift.vue";

// import wtyTable from "@/components/wty-table";
import { payConfigurePay } from "@/api/v2/merchant.js";
import {
  merchantSetState,
  getServiceCreateMerchant
} from "@/api/service";
let pinyin = require("js-pinyin");
export default {
  name: "createMerchant",
  components: { swift },
  data() {
    return {
      wxMchInfo: {
        wx_mch_no: ""
      },
      searchmch_name: "",
      mch_type: "正常",
      modify: false,
      wtytbshow: true,
      wtytbList: [],
      formList: [],
      radioList: [
        {
          label: "停业",
          value: "0"
        },
        {
          label: "正常",
          value: "1"
        },
        {
          label: "休息",
          value: "2"
        }
      ],

      wtycolumnList: [
        {
          prop: "merchant_id",
          align: "center",
          label: "店铺ID",
          width: "100",
          fixed: "left"
        },
        {
          prop: "merchant_name",
          align: "center",
          label: "店铺名称",
          width: "300",
          fixed: false
        }
      ],
      merchant: {
        state: "",
        mch_name: "", //店铺名称
        sub_name: "", //店铺简称
        mobile_no: "", //联系人手机号码
        pass_word: "", //登录密码
        license_code: "", //营业执照
        address: "", //店铺地址
        contacts_man: "", //联系人姓名
        e_mail: "", //电子邮箱
        phone: "", //固定电话
        fax: "", //传真号码
        pym: "", //拼音码
        service_phone: "", //服务热线
        mch_type: "01" //店铺类型号
      }
    };
  },
  mounted() {
    this.getMearchant();
  },
  methods: {

    createNewSwift() {
      //TODO:重置
      this.$refs.swiftRef.flush();
    },
    searchMchName() {
      this.$refs.wtyTableRef.wtyTableIn(this.searchmch_name);
      this.modify = false;
      // this.$refs.dataFormRef.resetFields();
      this.$refs.wtyTableRef.hideRow();
    },
    wtyTbreturn(res) {
      this.modify = false;
      this.merchant = { ...res };
      this.merchant.mch_name = res.merchant_name;
      console.log("res------------------=====", res);
      // console.log(res);
      this.$refs.swiftRef.SwiftQuery(res);
    },

    //获取店铺
    async getMearchant() {
      this.wtytbshow = false;
      const result = await getServiceCreateMerchant();
      if (this.testR(result)) {
        this.wtytbList = result.data.resp_data;
      }
      this.wtytbshow = true;
    },
    /* getReturn(res) {
      if (JSON.stringify(res) == "{}") {
        this.warnMessage("未识别出有效内容，请重试");
      } else {
        this.successMessage("识别成功");
        this.merchant.mch_name = res.commpanyName;
        this.merchant.address = res.address;
        this.merchant.contacts_man = res.legalPerson;
        this.merchant.license_code = res.licenseCode;
      }

      // res.media_no = this.merchant.license_code;
    }, */
    returnClose(res) {
      console.log(res);
    },
    /* MerchantGenerate() {
      this.$refs.dataFormRef.validate(async vaild => {
        if (!vaild) {
          return;
        }
        var { ...data } = this.merchant;
        // data.pass_word = await this.$encrypt(this.merchant.pass_word);
        data.pass_word = await this.$encrypt(
          this.merchant.pass_word,
          "pass_word"
        );
        data.mobile_no = await this.$encrypt(
          this.merchant.license_code,
          "mobile_no"
        );
        //TODO: 先传一个测试的营业执照号记得改
        data.license_code = await this.$encrypt(
          this.merchant.license_code,
          "license_code"
        );
        const res = await merchantGenerate(data);
        if (testR(res)) {
          if (
            res.data.result_code == "SUCCESS" &&
            res.data.return_code == "SUCCESS" &&
            res.data.resp_data
          ) {
            this.successMessage("创建店铺成功!");
            this.getMearchant();
          }
        }
      });
    }, */
    subNameBlur(key) {
      if (key) {
        this.merchant.pym = pinyin.getCamelChars(this.merchant.sub_name);
      }
    },
    async saveType() {
      // console.log(this.merchant.state);
      // console.log(this.merchant.merchant_id);
      const res = await merchantSetState(
        this.merchant.merchant_id,
        this.merchant.state
      );
      if (this.testR(res)) {
        this.successMessage("店铺状态修改成功！");
        /* this.modify = false;
        this.$refs.dataFormRef.resetFields();
        this.$refs.wtyTableRef.hideRow(); */
      }
      if (this.wxMchInfo.wx_mch_no) {
        payConfigurePay(this.wxMchInfo).then(res => {
          if (
            res.data.return_code === "SUCCESS" &&
            res.data.result_code === "SUCCESS"
          ) {
            this.successMessage("wx店铺id修改成功");
          }
        });
      }
    },
    wtyRadioChange(res) {
      console.log(res);
      this.merchant.state = res;
    }
  }
};
</script>
<style lang="less" scoped>
.fa {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.title {
  border-bottom: 2px solid rgb(0, 89, 184);
  color: rgb(0, 89, 184);
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
}

.right {
  width: auto;
  min-width: 600px;
  float: left;
}

.el-input {
  width: 400px;
}

.wty-footer {
  height: 50px;

  .el-button {
    width: 200px;
  }
}
</style>
